export default "__VITE_ASSET__Cc9PQiJh__"